// extracted by mini-css-extract-plugin
export var clone = "_os-2";
export var displayNone = "_os-4";
export var expandableItem = "_os-5";
export var expanded = "_os-6";
export var folderItem = "_os-7";
export var ghost = "_os-1";
export var hidden = "_os-3";
export var pipeContainer = "_os-8";
export var wrapper = "_os-0";